<template>
    <div>
        <form id="form_turmas">
            <div class="row">
                <div class="col-sm-12">
                    <h4>Dados Básicos</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <InputIconGroup typeInput="text" idInput="titulo" iconInput="fa-info" labelInput="Titulo da turma">
                        &nbsp;
                    </InputIconGroup>
                </div>
                <div class="col-md-4">
                    <DateIconGroup v-if="!this.$route.params.idTurma" idInput="data_inicio" iconInput="fa-calendar" labelInput="Data de inicio">
                        (AAAA-MM-DD)
                    </DateIconGroup>
                </div>
                <div class="col-md-4">
                    <SelectIconGroup v-if="!this.$route.params.idTurma" idInput="id_plano_teorico" iconInput="fa-book" labelInput="Plano de Aula"
                    :optionsInput="optionsInputPlanos" :optionSelected="optionSelectedPlanos" style="padding-bottom: 4px;">
                    </SelectIconGroup>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <h4>Alunos</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <TableAlunos></TableAlunos>
                </div>
            </div>
            <br>
            <br>
            <div class="row">
                <div class="col-md-12 text-center">
                    <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                    <button class="btn btn-primary" id="btn_salvar" type="submit" @click="salvaInformacoes">
                        Salvar
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
import TurmasController from './TurmasController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import InputUploadGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputUploadGroup'
import InputCheckboxGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputCheckboxGroup'
import SelectIconGroup from '../../vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'
import TableAlunos from './TableAlunos'

window._ = require('lodash')

export default {
  name: 'form-turma',
  components: {
    TableAlunos,
    SelectIconGroup,
    InputUploadGroup,
    InputIconGroup,
    InputCheckboxGroup,
    DateIconGroup,

  },
  data () {
    return {
      content: {
        load: true
      },
      urlCep: 'https://viacep.com.br/ws/',
      optionsInputPlanos: [{
        id: '',
        value: 'Selecione um plano de aula'
      }],
      optionSelectedPlanos: '',
    }
  },
  mounted () {
    let self = this

    TurmasController.getPlanos(function (data) {
        data.dados.map(function (value) {
            self.optionsInputPlanos.push({ id: value.id_plano_teorico, value: value.titulo })
        })
    })

    if (this.$route.params.idTurma) {
      TurmasController.carregaFormularioDeEdicao(this.$route.params.idTurma)
    }
  },
  methods: {
    salvaInformacoes () {
      if (this.$route.params.idTurma) {
        TurmasController.update(this.$route.params.idTurma)
      } else {
        TurmasController.store()
      }
    },
    loadData () {
      this.table.load = true
      this.$http.get(this.urlCep + this.search + '/json/').then(this.callbackDataPaginate)
    },
  }
}
</script>
